/* eslint-disable default-param-last */
/* eslint-disable no-case-declarations */
import { Reducer } from 'redux';
import produce from 'immer';
import _ from 'underscore';

import { BiddingTypes, BiddingState, CommentsRequestState } from './types';

const INITIAL_STATE: BiddingState = {
  biddings: {
    bidding_list: [],
    total_entries: 0,
    count_biddings_today: 0,
    count_biddings_future: 0,
    biddings_by_state: [],
    solicitation_edital_status: false,
    solicitation_edital_message: '',
    bidding_expired: {},
    bidding_detail: null,
  },
  comments: {},
  request: {
    get_biddings: {
      loading: false,
      loaded: false,
      error: false,
    },
    get_bidding: {
      loading: false,
      loaded: false,
      error: false,
    },
    get_bidding_pr_bw: {
      loading: false,
      loaded: false,
      error: false,
    },
    create_favorite_bidding: {
      loading: false,
      loaded: false,
      error: false,
    },
    destroy_favorite_bidding: {
      loading: false,
      loaded: false,
      error: false,
    },
    create_managed_bidding: {
      loading: false,
      loaded: false,
      error: false,
    },
    destroy_managed_bidding: {
      loading: false,
      loaded: false,
      error: false,
    },
    solicitar_edital: {
      loading: false,
      loaded: false,
      error: false,
    },
    get_bidding_expired: {
      loading: false,
      loaded: false,
      error: false,
    },
    biddings_overview: {
      loading: false,
      loaded: false,
      error: false,
    },
  },
  comments_request: {},
};

const INITIAL_STATE_COMMENT: CommentsRequestState = {
  get_comments: {
    loading: false,
    loaded: false,
    error: false,
  },
  create_comment: {
    loading: false,
    loaded: false,
    error: false,
  },
  destroy_comment: {
    loading: false,
    loaded: false,
    error: false,
  },
};

const reducer: Reducer<BiddingState> = (
  state = INITIAL_STATE,
  {
    type,
    result,
    biddingId,
    biddings,
    contactName,
    profileId,
    commentId,
    contact_client_id,
    removeFromList,
    removedNames,
  },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case BiddingTypes.GET_BIDDINGS_REQUEST:
        draft.request.get_biddings = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;

      case BiddingTypes.GET_BIDDINGS_SUCCESS:
        draft.request.get_biddings = {
          loading: false,
          loaded: true,
          error: false,
        };
        draft.biddings.bidding_list = result.data.biddings;
        draft.biddings.total_entries = result.data.total_entries;
        break;

      case BiddingTypes.GET_BIDDINGS_FAILURE:
        draft.request.get_biddings = {
          loading: false,
          loaded: false,
          error: true,
        };
        draft.biddings = INITIAL_STATE.biddings;
        break;

      case BiddingTypes.GET_BIDDING_REQUEST:
        draft.request.get_bidding = {
          ...INITIAL_STATE.request.get_bidding,
          loading: true,
        };
        break;

      case BiddingTypes.GET_BIDDING_SUCCESS: {
        draft.request.get_bidding = {
          ...INITIAL_STATE.request.get_bidding,
          loaded: true,
        };
        const existingBiddingIndex = state.biddings.bidding_list.findIndex(
          (b) => Number(b.id) === Number(result.data.id),
        );
        if (existingBiddingIndex !== -1) {
          draft.biddings.bidding_list[existingBiddingIndex] = result.data;
        } else {
          draft.biddings.bidding_list = [...state.biddings.bidding_list, result.data];
        }
        break;
      }

      case BiddingTypes.GET_BIDDING_FAILURE:
        draft.request.get_bidding = {
          ...INITIAL_STATE.request.get_bidding,
          error: true,
        };
        break;

      case BiddingTypes.CREATE_BIDDING_FAVORITE_REQUEST:
        draft.request.create_favorite_bidding = {
          ...INITIAL_STATE.request.create_favorite_bidding,
          loading: true,
        };
        break;

      case BiddingTypes.CREATE_BIDDING_FAVORITE_SUCCESS:
        const createFavoriteBiddingIndex = state.biddings.bidding_list.findIndex(
          (bidding) => Number(bidding.id) === Number(biddingId),
        );

        // Guard: bidding pode não estar no bidding_list (ex.: favoritar a
        // partir de BiddingDetails, página de detalhes que não passa pelo
        // cache da busca). Atribuir em índice -1 cria entrada negativa.
        if (createFavoriteBiddingIndex !== -1) {
          draft.biddings.bidding_list[createFavoriteBiddingIndex].favorited = true;
          draft.biddings.bidding_list[createFavoriteBiddingIndex].favorited_by = _.uniq([
            ...state.biddings.bidding_list[createFavoriteBiddingIndex].favorited_by,
            contactName,
          ]);
        }

        draft.request.create_favorite_bidding = {
          ...INITIAL_STATE.request.create_favorite_bidding,
          loaded: true,
        };
        break;

      case BiddingTypes.CREATE_BIDDING_FAVORITE_FAILURE:
        draft.request.create_favorite_bidding = {
          ...INITIAL_STATE.request.create_favorite_bidding,
          error: true,
        };
        break;

      case BiddingTypes.DESTROY_BIDDING_FAVORITE_REQUEST:
        draft.request.destroy_favorite_bidding = {
          ...INITIAL_STATE.request.destroy_favorite_bidding,
          loading: true,
        };
        break;

      case BiddingTypes.DESTROY_BIDDING_FAVORITE_SUCCESS:
        const destroyFavoriteBiddingIndex = state.biddings.bidding_list.findIndex(
          (bidding) => Number(bidding.id) === Number(biddingId),
        );

        // Guard: ver comentário em CREATE_BIDDING_FAVORITE_SUCCESS.
        if (destroyFavoriteBiddingIndex !== -1) {
          draft.biddings.bidding_list[destroyFavoriteBiddingIndex].favorited = false;
          draft.biddings.bidding_list[destroyFavoriteBiddingIndex].favorited_by =
            state.biddings.bidding_list[destroyFavoriteBiddingIndex].favorited_by.filter(
              (contacts) => contacts !== contactName,
            );
        }
        break;

      case BiddingTypes.DESTROY_BIDDING_FAVORITE_FAILURE:
        draft.request.destroy_favorite_bidding = {
          ...INITIAL_STATE.request.destroy_favorite_bidding,
          error: true,
        };
        break;

      case BiddingTypes.DESTROY_BIDDING_FAVORITE_ALL_REQUEST:
        draft.request.destroy_favorite_bidding = {
          ...INITIAL_STATE.request.destroy_favorite_bidding,
          loading: true,
        };
        break;

      case BiddingTypes.DESTROY_BIDDING_FAVORITE_ALL_SUCCESS: {
        const responseRemovedIds: Array<number> | undefined = result?.data?.removed_bidding_ids;

        if (removeFromList) {
          let idsToProcess: Array<number> = [];

          if (Array.isArray(responseRemovedIds) && responseRemovedIds.length > 0) {
            idsToProcess = responseRemovedIds.map((id: number) => Number(id));
          } else {
            const selectedSet = Array.isArray(biddings)
              ? new Set(biddings.map((id: number) => Number(id)))
              : null;
            idsToProcess = state.biddings.bidding_list
              .filter((b) => b.favorited && (selectedSet === null || selectedSet.has(Number(b.id))))
              .map((b) => Number(b.id));
          }

          if (idsToProcess.length > 0) {
            const processSet = new Set(idsToProcess);
            let removedFromListCount = 0;

            draft.biddings.bidding_list = state.biddings.bidding_list.flatMap((b) => {
              if (!processSet.has(Number(b.id))) return [b];

              const remainingFavoritedBy = (b.favorited_by || []).filter(
                (contact) => !removedNames.includes(contact),
              );

              if (remainingFavoritedBy.length === 0) {
                removedFromListCount += 1;
                return [];
              }

              return [
                {
                  ...b,
                  favorited: b.favorited && !removedNames.includes(contactName),
                  favorited_by: remainingFavoritedBy,
                },
              ];
            });

            draft.biddings.total_entries = Math.max(
              0,
              state.biddings.total_entries - removedFromListCount,
            );
          }
        } else if (Array.isArray(biddings)) {
          biddings.forEach((id) => {
            const index = state.biddings.bidding_list.findIndex(
              (bidding) => Number(bidding.id) === Number(id),
            );

            if (index !== -1) {
              draft.biddings.bidding_list[index].favorited = false;
              draft.biddings.bidding_list[index].favorited_by = draft.biddings.bidding_list[
                index
              ].favorited_by.filter((contact) => contact !== contactName);
            }
          });
        } else if (biddings === 'all') {
          draft.biddings.bidding_list = draft.biddings.bidding_list.map((bidding) => ({
            ...bidding,
            favorited: false,
            favorited_by: [],
          }));
        }

        draft.request.destroy_favorite_bidding = {
          ...INITIAL_STATE.request.destroy_favorite_bidding,
          loaded: true,
        };

        break;
      }

      case BiddingTypes.DESTROY_BIDDING_FAVORITE_ALL_FAILURE:
        draft.request.destroy_favorite_bidding = {
          ...INITIAL_STATE.request.destroy_favorite_bidding,
          error: true,
        };
        break;

      case BiddingTypes.CREATE_BIDDING_MANAGED_REQUEST:
        draft.request.create_managed_bidding = {
          ...INITIAL_STATE.request.create_managed_bidding,
          loading: true,
        };
        break;

      case BiddingTypes.CREATE_BIDDING_MANAGED_SUCCESS:
        const createManagedBiddingIndex = state.biddings.bidding_list.findIndex(
          (bidding) => bidding.id === biddingId,
        );

        // Guard: bidding pode não estar no bidding_list (ex.: gerenciar a partir
        // de BiddingDetails). Atribuir em índice -1 cria entrada negativa.
        if (createManagedBiddingIndex !== -1) {
          draft.biddings.bidding_list[createManagedBiddingIndex].managed = true;
          draft.biddings.bidding_list[createManagedBiddingIndex].managers =
            result.data.managed.managers;
        }

        draft.request.create_managed_bidding = {
          ...INITIAL_STATE.request.create_managed_bidding,
          loaded: true,
        };
        break;

      case BiddingTypes.CREATE_BIDDING_MANAGED_FAILURE:
        draft.request.create_managed_bidding = {
          ...INITIAL_STATE.request.create_managed_bidding,
          error: true,
        };
        break;

      case BiddingTypes.DESTROY_BIDDING_MANAGED_REQUEST:
        draft.request.destroy_managed_bidding = {
          ...INITIAL_STATE.request.destroy_managed_bidding,
          loading: true,
        };
        break;

      case BiddingTypes.DESTROY_BIDDING_MANAGED_SUCCESS:
        draft.request.destroy_managed_bidding = {
          ...INITIAL_STATE.request.destroy_managed_bidding,
          loaded: true,
        };
        const destroyManagedBiddingIndex = state.biddings.bidding_list.findIndex(
          (bidding) => bidding.id === biddingId,
        );

        // Guard: ver comentário em CREATE_BIDDING_MANAGED_SUCCESS. Acessar
        // bidding_list[-1].managers crasharia com undefined.
        if (destroyManagedBiddingIndex !== -1) {
          const bidding = draft.biddings.bidding_list[destroyManagedBiddingIndex];

          bidding.managers = bidding.managers.filter(
            (manager) => manager.user_id !== contact_client_id,
          );

          if (bidding.managers.length > 0) {
            bidding.managed = false;
          } else {
            draft.biddings.bidding_list[destroyManagedBiddingIndex].managed = false;
            draft.biddings.bidding_list[destroyManagedBiddingIndex].managers = bidding.managers;
          }
        }

        draft.request.destroy_managed_bidding = {
          ...INITIAL_STATE.request.destroy_managed_bidding,
          loaded: true,
        };
        break;

      case BiddingTypes.DESTROY_BIDDING_MANAGED_FAILURE:
        draft.request.destroy_managed_bidding = {
          ...INITIAL_STATE.request.destroy_managed_bidding,
          error: true,
        };
        break;

      case BiddingTypes.GET_COMMENTS_REQUEST:
        draft.comments_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          get_comments: {
            ...INITIAL_STATE_COMMENT.get_comments,
            loading: true,
          },
        };
        break;

      case BiddingTypes.GET_COMMENTS_SUCCESS:
        draft.comments_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          get_comments: {
            ...INITIAL_STATE_COMMENT.get_comments,
            loaded: true,
          },
        };

        draft.comments[biddingId] = result.data?.data ? [] : result.data;

        break;

      case BiddingTypes.GET_COMMENTS_FAILURE:
        draft.comments_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          get_comments: {
            ...INITIAL_STATE_COMMENT.get_comments,
            error: true,
          },
        };
        break;

      case BiddingTypes.CREATE_COMMENT_REQUEST:
        draft.comments_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          create_comment: {
            ...INITIAL_STATE_COMMENT.create_comment,
            loading: true,
          },
        };
        break;

      case BiddingTypes.CREATE_COMMENT_SUCCESS: {
        draft.comments_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          create_comment: {
            ...INITIAL_STATE_COMMENT.create_comment,
            loaded: true,
          },
        };

        const comment = {
          id: result.data.id,
          message: result.data.message,
          created_at: result.data.created_at,
          contact_client: {
            id: profileId,
            nome: contactName,
          },
        };

        draft.comments[biddingId] = [...(draft.comments[biddingId] || []), comment];

        const biddingIndex = draft.biddings.bidding_list.findIndex(
          (b) => Number(b.id) === Number(biddingId),
        );

        if (biddingIndex !== -1) {
          const existing = draft.biddings.bidding_list[biddingIndex].client_comments || [];
          draft.biddings.bidding_list[biddingIndex].client_comments = [...existing, comment];
        }

        break;
      }

      case BiddingTypes.CREATE_COMMENT_FAILURE:
        draft.comments_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          create_comment: {
            ...INITIAL_STATE_COMMENT.create_comment,
            error: true,
          },
        };
        break;

      case BiddingTypes.DESTROY_COMMENT_REQUEST:
        draft.comments_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          destroy_comment: {
            ...INITIAL_STATE_COMMENT.destroy_comment,
            loading: true,
          },
        };
        break;

      case BiddingTypes.DESTROY_COMMENT_SUCCESS: {
        draft.comments_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          destroy_comment: {
            ...INITIAL_STATE_COMMENT.destroy_comment,
            loaded: true,
          },
        };

        draft.comments[biddingId] = (draft.comments[biddingId] || []).filter(
          (comment) => Number(comment.id) !== Number(commentId),
        );

        const biddingIndex = draft.biddings.bidding_list.findIndex(
          (bidding) => Number(bidding.id) === Number(biddingId),
        );

        if (biddingIndex !== -1) {
          draft.biddings.bidding_list[biddingIndex].client_comments = draft.biddings.bidding_list[
            biddingIndex
          ].client_comments.filter((comment) => Number(comment.id) !== Number(commentId));
        }

        break;
      }

      case BiddingTypes.DESTROY_COMMENT_FAILURE:
        draft.comments_request[biddingId] = {
          ...INITIAL_STATE_COMMENT,
          destroy_comment: {
            ...INITIAL_STATE_COMMENT.destroy_comment,
            error: true,
          },
        };
        break;

      case BiddingTypes.GET_BIDDING_PR_BW_REQUEST:
        draft.request.get_bidding_pr_bw = {
          ...INITIAL_STATE.request.get_bidding_pr_bw,
          loading: true,
        };
        break;

      case BiddingTypes.GET_BIDDING_PR_BW_SUCCESS:
        draft.request.get_bidding_pr_bw = {
          ...INITIAL_STATE.request.get_bidding_pr_bw,
          loaded: true,
        };
        draft.biddings.bidding_list = [...state.biddings.bidding_list, result.data?.bidding];

        break;

      case BiddingTypes.GET_BIDDING_PR_BW_FAILURE:
        draft.request.get_bidding_pr_bw = {
          ...INITIAL_STATE.request.get_bidding_pr_bw,
          error: true,
        };
        break;

      case BiddingTypes.UPDATE_STORE_FIELDS:
        if (!state.biddings) draft.biddings = INITIAL_STATE.biddings;
        if (!state.comments) draft.comments = INITIAL_STATE.comments;
        if (!state.comments_request) draft.comments_request = INITIAL_STATE.comments_request;
        if (!state.request) draft.request = INITIAL_STATE.request;
        if (!state.biddings) draft.biddings = INITIAL_STATE.biddings;
        if (!state.comments_request) draft.comments_request = INITIAL_STATE.comments_request;
        if (!state.request.destroy_managed_bidding)
          draft.request.destroy_managed_bidding = INITIAL_STATE.request.destroy_managed_bidding;
        break;

      case BiddingTypes.SOLICITAR_EDITAL_REQUEST:
        draft.biddings.solicitation_edital_status =
          INITIAL_STATE.biddings.solicitation_edital_status;
        draft.biddings.solicitation_edital_message =
          INITIAL_STATE.biddings.solicitation_edital_message;
        draft.request.solicitar_edital = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;

      case BiddingTypes.SOLICITAR_EDITAL_SUCCESS:
        draft.biddings.solicitation_edital_status = result?.data?.status;
        draft.biddings.solicitation_edital_message = result?.data?.message;
        draft.request.solicitar_edital = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;

      case BiddingTypes.SOLICITAR_EDITAL_FAILURE:
        draft.biddings.solicitation_edital_status =
          INITIAL_STATE.biddings.solicitation_edital_status;
        draft.biddings.solicitation_edital_message =
          INITIAL_STATE.biddings.solicitation_edital_message;
        draft.request.solicitar_edital = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case BiddingTypes.GET_BIDDING_EXPIRED_REQUEST:
        draft.biddings.bidding_detail = INITIAL_STATE.biddings.bidding_detail;
        draft.request.get_bidding_expired = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;

      case BiddingTypes.GET_BIDDING_EXPIRED_SUCCESS:
        draft.biddings.bidding_detail = result?.data;
        draft.request.get_bidding_expired = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;

      case BiddingTypes.GET_BIDDING_EXPIRED_FAILURE:
        draft.biddings.bidding_detail = INITIAL_STATE.biddings.bidding_detail;
        draft.request.get_bidding_expired = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case BiddingTypes.BIDDINGS_OVERVIEW_REQUEST:
        draft.biddings.count_biddings_future = INITIAL_STATE.biddings.count_biddings_future;
        draft.biddings.biddings_by_state = INITIAL_STATE.biddings.biddings_by_state;
        draft.biddings.count_biddings_today = INITIAL_STATE.biddings.count_biddings_today;
        draft.request.biddings_overview = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;

      case BiddingTypes.BIDDINGS_OVERVIEW_SUCCESS:
        draft.biddings.count_biddings_future = result?.data?.total_biddings_future;
        draft.biddings.biddings_by_state = result?.data?.all_states;
        draft.biddings.count_biddings_today = result?.data?.count_bidding_today;
        draft.request.biddings_overview = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;

      case BiddingTypes.BIDDINGS_OVERVIEW_FAILURE:
        draft.biddings.count_biddings_future = INITIAL_STATE.biddings.count_biddings_future;
        draft.biddings.biddings_by_state = INITIAL_STATE.biddings.biddings_by_state;
        draft.biddings.count_biddings_today = INITIAL_STATE.biddings.count_biddings_today;
        draft.request.biddings_overview = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      default:
        break;
    }
  });
};

export default reducer;
